import React, { useRef, useEffect, useState } from 'react';

import Header from './Header';
import Footer from './Footer';
import '../styles/AboutUs.css';
import team_illustration from '../assets/team_illustration.jpeg'; // Replace with your actual image
import workerImage from '../assets/worker.png'; // Replace with your actual image
import chooseUsImage from '../assets/chooseUsImage.jpg'
import { FaPaperPlane,FaChevronRight } from 'react-icons/fa';
import Counter from "./Counter"
import ourvalue from '../assets/ourvalue.png';
// import robotics from '../assets/robotic-process-automation-concept_220873-395.avif';
// import Counter from '../components/Counter';


const AboutUs = ({target }) => {

  
  const statsRef = useRef(null);
const [hasAnimated, setHasAnimated] = useState(false);

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setHasAnimated(true);
        }
      });
    },
    { threshold: 0.5 }
  );

  if (statsRef.current) {
    observer.observe(statsRef.current);
  }

  return () => {
    if (statsRef.current) {
      observer.unobserve(statsRef.current);
    }
  };
}, []);


const [email, setEmail] = useState('');
const handleSubmit1 = (e) => {
  e.preventDefault();

  if (!email) {
    alert('Please enter your email address.');
    return;
  }

  const subject = "Request for Quote";
  const body = `Hello,\n\nI would like a quote. My email is: ${email}`;
  const mailtoLink = `mailto:sales@fu-tekautomation.co.in?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  window.location.href = mailtoLink;

  setEmail('');
};


  
  return (
    <div className="aboutus">
      <Header />

{/* Hero Banner Section */}
<section className="hero-banner1">
  <div className="hero-content">
  <h1>ABOUT US</h1>
    <div className="breadcrumb">
      <span><a href="/">Home</a></span> <FaChevronRight /> <span>About Us</span>
    </div>
   </div>
</section>



      <section className="futek-section">
      <div className="futek-container">
        <div className="futek-left">
          <h2>WELCOME TO<br /><span className="highlight">THE “FU-TEK” Philosophy</span></h2>
          <p>
            The brand FU-TEK started its journey in 2016 as a small company with a handful of people,
            and has now grown into a large organization. FU-TEK AUTOMATION steadily expanded operations
            and moved to our current headquarters in Vadodara, Gujarat.
          </p>
          <p>
            Today, FU-TEK AUTOMATION is having a wide experience in Industrial Automation Sector to
            Supply and Execute Control Systems in areas of process. The industries served are
            Pharmaceutical, Food & Beverages, Automobile, Textile, Chemical, Metal and Cement.
            Our business area covers Consultancy, Design, Engineering, Manufacturing, and
            Commissioning and Installation.
          </p>
          <button className="read-more">Read More</button>
        </div>
        <div className="futek-right">
          <img src={team_illustration} alt="Team Illustration" />
        </div>
      </div>
    </section>

    <section className="futek-highlight-section">
  <div className="futek-highlight-container">
    <p>
      Recognized as one of the premier industrial automation solution providers, 
      <strong> FU-TEK AUTOMATION </strong> serves nearly 100 customers in about 20 vertical industrial segments, 
      offering products, solutions and services through 5 regional offices and a wide network of Dealers and System Integrators.
    </p>
    <p>
      Our goal is to exceed the expectations of every customer by offering innovative industrial automation solutions, 
      outstanding customer service and greater value addition, thereby optimizing process functionality and improving 
      operation efficiency of the industry. Our team is distinguished by their functional and technical expertise combined 
      with their hands-on experience, thereby ensuring that our customers receive the most effective and value based 
      solutions for their requirements.
    </p>
  </div>
</section>


    {/* Work Process Section */}
    <section className="work-process">
        <h2>Our Work Process</h2>
        <img src={ourvalue} alt="ourvalue" className="ourvalue-img" />
      </section>

      {/* Stats Section */}
<section className="stats-section" ref={statsRef}>
  <div className="stats-boxes">
    <div>{hasAnimated ? <Counter target={100} /> : <h3>0+</h3>}<p>Projects</p></div>
    <div>{hasAnimated ? <Counter target={200} /> : <h3>0+</h3>}<p>Clients</p></div>
    <div>{hasAnimated ? <Counter target={100} /> : <h3>0%</h3>}<p>Satisfaction</p></div>
  </div>
  <img src={workerImage} alt="Worker" className="worker-img" />
</section>
      {/* Team Quote Section */}
      <section className="quote-section">
        <p>
          Our team is distinguished by their functional and technical expertise
          combined with their hands-on experience, thereby ensuring that our
          customers receive the most effective and value based solutions for their
          requirements.
        </p>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <div className="why-choose-content">
          <img src={chooseUsImage} alt="Why You Choose Us" />
          <div className="why-text">
            <h3>Why You Choose Us</h3>
            <p>
              FU-TEK AUTOMATION has been quick to adopt and incorporate new
              technologies like IIoT (Industrial Internet Of Things), Ethernet and
              Wireless into the industrial automation solutions that are offered.
              Today, we have many proven track records of very appreciable product
              and solution in SCADA/PLC/DCS platforms that have been successfully
              installed at several sites.
            </p>
            <ul>
              <li>⚙️ Create Technology</li>
              <li>🚚 Delivery On-time</li>
              <li>🧑‍🔧 Certified Engineers</li>
              <li>🏅 Best Branding</li>
            </ul>
          </div>
        </div>
      </section>

 <div className="quote-banner1">
      <div className="quote-text">
        <h2>Need Help with Automation?</h2>
        <p>Get a free consultation from our certified engineers today.</p>
      </div>
      <div className="quote-input">
<form className="quote-input" onSubmit={handleSubmit1}>
      <input
        type="email"
        placeholder="Your email address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <button type="submit">➤</button>
    </form>
          </div>
    </div>
    
<section className="futek-philosophy-section">
  <div className="philosophy-container">
    <h2>The “FU-TEK” Philosophy</h2>

    <h3>Corporate Mission</h3>
    <p>Our mission is to grow consistently by 30% Year on Year, using the best global technologies in products and services offered to customers.</p>

    <h3>Corporate Vision</h3>
    <p>Our vision is to become the Most Admired Indian Company in the field of Automation and Instrumentation.</p>

    <h3>FU-TEK AUTOMATION Value System</h3>
    <ul>
      <li>Transparent, legal and ethical business practices</li>
      <li>Facilitating continuous improvement of technical and leadership skills in our people</li>
      <li>Safety of our people and customers</li>
      <li>Maintaining a clean and green environment</li>
    </ul>

    <h3>Core Business Ideals</h3>
    <p>At FU-TEK AUTOMATION, we believe that a satisfied customer is the best reward:</p>
    <ul>
      <li>Extensive Domain Knowledge</li>
      <li>High quality and latest design experience</li>
      <li>Best industrial integration expertise</li>
      <li>Competent manufacturing capabilities</li>
      <li>World class products and solutions</li>
    </ul>

    <p>
      <strong>FU-TEK AUTOMATION</strong> is a leading Manufacturer, Exporter and Supplier of a wide range of optimum quality Process Control Instruments.
      The proven range of technologically upgraded instruments offered by us consists of PID Controller, Data Loggers, Chart Recorder,
      On-line Analyzer, Leak Detector, Digital Panel Instruments, Temperature Transmitters, Flow Control Valves, Flow Meter,
      Flow Metering Skid, Field Instruments, Electromagnetic Flow Meter, Flow Switches and many more.
    </p>
    <p>
      Our products are the best in terms of quality and working and have achieved a lot of acclamation from our clients spread worldwide.
    </p>
    <p>
      We are a total customer driven company and we strive hard to achieve total satisfaction of our customers.
      We provide one of the best products that are authentic and are well-known for their effectual functioning.
      Our products can be availed at quite affordable prices within the stipulated time.
      Lastly, we value each and every client we have and try our level best to serve them with utmost care.
    </p>
  </div>
</section>


      <Footer />
    </div>
  );
};

export default AboutUs;
